<template>
    <div class="filter-panel">
        <div class="filter-control">
            <div style="width: 100%!important">
                <div class="d-flex justify-content-between">
                    <div>
                        <a href="javascript:void(0)" class="text-secondary mb-0"><b>{{this.openFilter? 'Filtra risultati' : 'Imposta filtro'}}</b><span> | {{counter}}</span></a>
                    </div>
                    <div>
                        <button class="btn btn-sm btn-secondary mr-2">reset</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DefaultModal from '../../../../../back/components/pages/layout/DefaultModal'

export default {
  name: 'FilterMainTourPanel',
  components: {DefaultModal},
  props: {
    isFrom: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      openFilter: false,
      filter: {},
      counter: 0
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/tour-accompagnati/FilterMainTourPanel.vue